module.exports = __webpack_public_path__ + "static/media/business-health-check.fdcb2489.jpg";